import React from 'react';
import { Section } from './ui/Section';
export function WhoIsThisForSection() {
  return <Section data-id="element-191">
      <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#faf6f0] mb-12 text-center" data-id="element-192">
        Who this is for
      </h2>

      <div className="space-y-12" data-id="element-193">
        <div data-id="element-194">
          <h3 className="text-xl font-bold text-[#8fae8b] mb-4 uppercase tracking-wider" data-id="element-195">
            This is for you if:
          </h3>
          <ul className="space-y-4 text-lg md:text-xl text-[#f5f0e8]" data-id="element-196">
            {["Your baby sleeps great on you and 'hates the bassinet'", "You're exhausted and you feel your safety margin shrinking", "You want a safer sleep solution that isn't 'cry it out'", "You want a script you can follow even when you're shaking with fatigue"].map((item, i) => <li key={i} className="flex items-start" data-id="element-197">
                <span className="text-[#8fae8b] mr-3" data-id="element-198">✓</span>
                <span data-id="element-199">{item}</span>
              </li>)}
          </ul>
        </div>

        <div data-id="element-200">
          <h3 className="text-xl font-bold text-[#c97a7a] mb-4 uppercase tracking-wider" data-id="element-201">
            This is NOT for you if:
          </h3>
          <ul className="space-y-4 text-lg md:text-xl text-[#f5f0e8]" data-id="element-202">
            {['You want a magic product that works in one night', "You're looking for medical diagnosis or treatment", 'You want to ignore safe-sleep guidance and just be told what you want to hear'].map((item, i) => <li key={i} className="flex items-start" data-id="element-203">
                <span className="text-[#c97a7a] mr-3" data-id="element-204">✕</span>
                <span data-id="element-205">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}